import { defineStore } from 'pinia'
import { USER_INFO } from '@/store/constant/cacheKey'
import { Local } from '/@/utils/storage'
import type { UserInfo } from '@/store/interface'

export const useUserInfo = defineStore('userInfo', {
	state: (): UserInfo => {
		return {
			id: 0,
			realname: '',
			email: '',
			phone_num: '',
			email_verified: false,
			phone_verified: false,
			phone: {
				phone_pre: '',
				phone_num: '',
			},
			country: '',
			companyname: '',
			postcode: '',
			phonenumber: '',
			company: '',
			language: '',
			language_object: {
				text: '',
				type: '',
			},
			state: '',
			city: '',
			address1: '',
			address2: '',
			last_login: '',
			last_ip: '',
			token: '',
			refresh_token: '',
			expires_time: '',
			refresh_expires_time: '',
			has_password: false,
		}
	},
	actions: {
		/**
		 * 状态批量填充
		 * @param state 新状态数据
		 * @param [exclude=true] 是否排除某些字段（忽略填充），默认值 true 排除 token 和 refresh_token，传递 false 则不排除，还可传递 string[] 指定排除字段列表
		 */
		dataFill(state: Partial<UserInfo>, exclude: boolean | string[] = true) {
			if (exclude === true) {
				exclude = ['token', 'refresh_token']
			} else if (exclude === false) {
				exclude = []
			}

			if (Array.isArray(exclude)) {
				exclude.forEach((item) => {
					delete state[item as keyof UserInfo]
				})
			}

			this.$patch(state)
		},
		removeToken() {
			this.token = ''
			this.refresh_token = ''
		},
		setToken(token: string, type: 'auth' | 'refresh') {
			const field = type == 'auth' ? 'token' : 'refresh_token'
			this[field] = token
		},
		getToken(type: 'auth' | 'refresh' = 'auth') {
			return type === 'auth' ? this.token : this.refresh_token
		},
		/* getGenderIcon() {
			let icon = { name: 'fa fa-transgender-alt', color: 'var(--el-text-color-secondary)' }
			switch (this.gender) {
				case 1:
					icon = { name: 'fa fa-mars-stroke-v', color: 'var(--el-color-primary)' }
					break
				case 2:
					icon = { name: 'fa fa-mars-stroke', color: 'var(--el-color-danger)' }
					break
			}
			return icon
		}, */
		logout() {
			this.removeToken()
			// 动态导入避免循环依赖
			import('../api/User').then((m) => m.postLogout().then(() => {}))
			Local.remove(USER_INFO)
		},
		isLogin() {
			return this.id && this.token
		},
	},
	persist: {
		key: USER_INFO,
	},
})
